<template>
  <div
    class="notes-inline"
    :class="pageThemeClass"
  >
    <div
      v-if="textNotes"
      class="notes-inline__text-modules"
    >
      <ModuleWrapper
        v-for="mod in textNotes"
        :key="mod.id"
        mode="VIEW"
        :module-data="mod"
        canvas-name="notes"
        :scale="1"
        :id="mod.id"
        class="notes-inline__text-module"
      >
        <TextModule
          :id="mod.id"
          mode="VIEW"
          :module-data="mod"
          :scale="1"
          canvas-name="notes"
          :size-to-parent="false"
          :page="page"
        />
      </ModuleWrapper>
    </div>
    <div
      v-if="assetUploadNotes"
      class="notes-inline__asset-upload-modules"
    >
      <ModuleWrapper
        v-for="mod in assetUploadNotes"
        :key="mod.id"
        mode="VIEW"
        :module-data="mod"
        canvas-name="notes"
        :scale="1"
        :id="mod.id"
        :style="dynamicStyles(mod)"
        class="notes-inline__asset-upload-module"
      >
        <component
          :is="moduleTypeToComponent(mod.type)"
          :id="mod.id"
          mode="VIEW"
          :module-data="mod"
          :scale="1"
          canvas-name="notes"
          :page="page"
        />
      </ModuleWrapper>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';
import chain from '@/lib/utils/chain';
import { moduleTypeToComponent } from '@/lib/utils';
import { heightToPixels } from '@/lib/utils/grid';
import ModuleWrapper from '@/components/ModuleWrapper.vue';
import modules from '@/components/modules/index';

export default {
  name: 'NotesInline',
  components: {
    ModuleWrapper,
    ...modules,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    assetUploadNotes() {
      const assetUploadNotes = this.getNotesModulesByTypes(['asset', 'upload']);
      return assetUploadNotes?.length ? assetUploadNotes : null;
    },
    pageThemeClass() {
      const themeName = get(this.page, 'options.theme.name', 'default');
      return `editor-theme--${themeName}`;
    },
    textNotes() {
      const textNotes = this.getNotesModulesByTypes(['text']);
      return textNotes?.length ? textNotes : null;
    },
    dynamicStyles() {
      return (mod) => ({
        height: this.windowWidth <= 768 || this.printNotes ? '100%' : `${this.heightToPixels(mod.layout.height)}px`,
      });
    },
    printNotes() {
      return get(this, '$route.query.printNotes') === 'true';
    },
  },
  methods: {
    moduleTypeToComponent,
    heightToPixels,
    getNotesModulesByTypes(moduleTypes) {
      return chain(this.page.notes)
        .filter((mod) => moduleTypes.includes(mod.type))
        .sortBy((mod) => mod.layout.y_position)
        .value();
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="stylus">
.notes-inline {
  &__text-modules {
    .notes-inline__text-module {
      margin-top: $nebula-space-2x;
    }
  }

  &__asset-upload-modules {
    display: grid;
    grid-gap: 10px;

    @media (min-width: $nebula-breakpoints-tablet-portrait),
    print {
      display: grid;
      grid-template-columns: 50% 50%;
      grid-gap: 10px;
    }

    .notes-inline__asset-upload-module {
      margin-top: $nebula-space-2x;
      min-height: 200px;
    }
  }
}
</style>
